"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var js_base64_1 = require("js-base64");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var office_ui_fabric_react_2 = require("office-ui-fabric-react");
var Speisekarte_1 = require("../Speisekarte");
var Slider_1 = require("../Slider");
var Events_1 = require("../Events");
var Admin = /** @class */ (function (_super) {
    __extends(Admin, _super);
    function Admin(props) {
        var _this = _super.call(this, props) || this;
        _this.userChanged = function (event, newValue) {
            _this.setState({ username: newValue });
        };
        _this.passChanged = function (event, newValue) {
            _this.setState({ password: newValue });
        };
        _this.logIn = function () {
            fetch('api/Zusatz/Stoffe/Get', {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + js_base64_1.Base64.encode(_this.state.username + ":" + _this.state.password)
                })
            })
                .then(function (response) { return response.json(); })
                .then(function () { return _this.setState({ hideDialog: true }); })
                .catch(function (error) { return _this.setState({ showError: true }); });
        };
        _this.state = { username: "", password: "", hideDialog: false, showError: false };
        return _this;
    }
    Admin.prototype.render = function () {
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement("div", null,
            this.state.hideDialog && React.createElement("div", null,
                React.createElement(Speisekarte_1.default, { isAdmin: true }),
                React.createElement(Slider_1.default, { isAdmin: true, folderName: "", fileName: "", deletedEvent: function () { } }),
                React.createElement(Events_1.default, { isAdmin: true })),
            React.createElement(Dialog_1.Dialog, { hidden: this.state.hideDialog, onDismiss: function () { }, dialogContentProps: {
                    type: Dialog_1.DialogType.normal,
                    title: 'Anmelden'
                }, modalProps: {
                    isBlocking: true,
                    styles: { main: { maxWidth: 6000 } }
                } },
                React.createElement(office_ui_fabric_react_2.Label, { style: { display: this.state.showError ? "block" : "none", color: theme.palette.themePrimary } }, "Benutzer/Passwort ist falsch!"),
                React.createElement(office_ui_fabric_react_2.TextField, { label: "Benutzer", required: true, onChange: this.userChanged }),
                React.createElement(office_ui_fabric_react_2.TextField, { label: "Passwort", required: true, type: "password", onChange: this.passChanged }),
                React.createElement(Dialog_1.DialogFooter, null,
                    React.createElement(office_ui_fabric_react_2.DefaultButton, { onClick: this.logIn, text: "Anmelden" })))));
    };
    return Admin;
}(React.Component));
exports.default = Admin;
//# sourceMappingURL=Admin.js.map